import { Dispatch, MutableRefObject, SetStateAction } from 'react'

export type SearchResult = {
    setData: Dispatch<SetStateAction<ResultSearchType[]>>
    keywordSearchRef: MutableRefObject<string>
    currentPageNoRef: MutableRefObject<number>
    allData: MutableRefObject<number>
}

export type ResultSearchType = {
    projectID: number
    createDate: string
    irb: number
    reseacherType: number
    academicLevel: number
    educationLevel: number | null
    prefixId: number
    titleNameOtherTh: string
    titleNameOtherEh: string
    nameTH: string
    nameEN: string
    fullnameTH: string
    fullnameEN: string
    projectNameTh: string
    projectNameEn: string
    isPhd: null
    certificateID: string
    otherAcademicLevelTh: string
    otherAcademicLevelEn: string
    certificateDate: string
}

export type SearchForm = {
    keywordSearch?: string
    pageNo: number
    pageSize: number
}

export type InputAdd = {
    projectID: string | null
    researcherType: number
    academicLevel: number | null
    educationLevel: number | null
    prefixID: number
    titleNameOtherTh?: string | null
    titleNameOtherEn?: string | null
    nameTh: string
    nameEn: string
    projectNameTh: string
    projectNameEn: string
    isPhd: boolean
    certificateDate: string
    otherAcademicLevelTh?: string | null
    otherAcademicLevelEn?: string | null
    certificateID: string
}

export type ListRequestType = {
    keywordSearch?: string
    pageNo: number
    pageSize: number
}

export type GetListAllResultType = {
    status: number
    message: string
    result: {
        data: ResultSearchType[]
        total: number
    }
}

export type NewExternalProjectResult = {
    status: number
    message: string
    result: {
        projectID: number
        certificateID: string
    }
}

export type UpdateExternalProjectResult = {
    status: number
    message: string
    result: null
}

export type DeleteExternalProjectResult = {
    status: number
    message: string
    result: null
}

export enum ResearcherType {
    student = '1',
    teacher = '2', // นักวิจัย/อาจารย์
}
